import React from 'react';
import { FileCheck, Users, Calendar, MessageSquare } from 'lucide-react';
import { t } from '../i18n';

const icons = [FileCheck, Users, Calendar, MessageSquare];

export default function ModulesSection({ lang }) {
  const c = t(lang);

  return (
    <section id="funciones" className="py-20 md:py-28 bg-[#0C3C3C] text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 30%, #5eead4 0%, transparent 40%), radial-gradient(circle at 80% 70%, #99f6e4 0%, transparent 35%)',
        }}
      />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-3">
            {c.modules.title}
          </h2>
          <p className="text-lg text-teal-100/70 leading-relaxed">{c.modules.lead}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-12">
          {c.modules.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div key={item.title} className="flex gap-5">
                <div className="shrink-0 w-11 h-11 rounded-md border border-teal-400/30 bg-teal-400/10 flex items-center justify-center text-teal-300">
                  <Icon size={20} />
                </div>
                <div>
                  <h3 className="font-display text-xl font-bold mb-2">{item.title}</h3>
                  <p className="text-teal-100/65 leading-relaxed">{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
